import React, { Component } from 'react'
import PropTypes from 'prop-types'
import I18n from 'lib/i18n'

export default class Design extends Component {
  static propTypes = {
    design: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    onSelect: PropTypes.func,
    caption: PropTypes.string,
    amount: PropTypes.number
  }

  render() {
    const className = ['gift_card', 'design', this.props.design.name]
    if (this.props.selected) className.push('selected')

    return (
      <div
        className={className.join(' ')}
        onClick={() => {
          this.props.onSelect && this.props.onSelect(this.props.design)
        }}
      >
        <div className="label">E-GIFT Certificate</div>
        <div className="caption">{this.props.caption || 'Your caption will be here'}</div>
        <div className="amount">{this.props.amount && I18n.numberToCurrency(this.props.amount)}</div>
      </div>
    )
  }
}
